import React, { useState, useEffect } from "react";
import { FiX, FiHeart, FiCoffee } from "react-icons/fi";
import "../styles/DonatePopup.css";

const DonatePopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkAndShowPopup = () => {
      const lastShown = localStorage.getItem("donatePopupLastShown");
      const isNewUser = !localStorage.getItem("isReturningUser");
      const currentTime = Date.now();

      // For new users (first visit)
      if (isNewUser) {
        // Show once per session
        const sessionShown = sessionStorage.getItem("donatePopupSessionShown");
        if (!sessionShown) {
          setIsVisible(true);
          sessionStorage.setItem("donatePopupSessionShown", "true");
          localStorage.setItem("isReturningUser", "true");
        }
      }
      // For returning users
      else if (lastShown) {
        const daysSinceLastShown =
          (currentTime - parseInt(lastShown)) / (1000 * 60 * 60 * 24);
        // Show every 1-7 days based on interaction frequency
        const showInterval = Math.min(
          7,
          Math.max(1, Math.floor(daysSinceLastShown))
        );
        if (daysSinceLastShown >= showInterval) {
          setIsVisible(true);
          localStorage.setItem("donatePopupLastShown", currentTime.toString());
        }
      }
    };

    // Check on initial load
    checkAndShowPopup();

    // Set up scroll trigger
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (scrolled > pageHeight * 0.6) {
        checkAndShowPopup();
      }
    };

    // Set up exit intent trigger
    const handleExitIntent = (e) => {
      if (e.clientY <= 0) {
        checkAndShowPopup();
      }
    };

    // Set up time trigger (after 30 seconds)
    const timeTrigger = setTimeout(() => {
      checkAndShowPopup();
    }, 30000);

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mouseleave", handleExitIntent);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mouseleave", handleExitIntent);
      clearTimeout(timeTrigger);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="himalblock-donate-popup">
      <button
        className="himalblock-close-button"
        onClick={handleClose}
        aria-label="Close"
      >
        <FiX />
      </button>
      <div className="himalblock-donate-content">
        <FiCoffee className="himalblock-coffee-icon" />
        <p className="himalblock-donate-message">
          If you'd be so kind, a coffee or a small contribution would truly keep
          my coding efforts brewing!
        </p>
        <a
          href="https://www.paypal.com/donate/?business=L5829VKPFQWGW&no_recurring=0&item_name=Hey%2C+big+thanks+for+your+awesome+support%21+Glad+you+liked+the+Himalblock+Cheatsheets%E2%80%94means+a+lot.+You+rock%21%0A%0A%0A%0A&currency_code=USD"
          className="himalblock-donate-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiHeart className="himalblock-heart-icon" />
          Buy me a coffee
        </a>
      </div>
    </div>
  );
};

export default DonatePopup;
